exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.test-question-answer-options[data-v-1467a57d] {\n  padding: 0 15px;\n}\n.test-question-answer-option-container[data-v-1467a57d] {\n  padding: 17px 0;\n}\n.text-max-length[data-v-1467a57d] {\n  font-size: 0.8rem;\n  text-align: right;\n  padding-top: 10px;\n  color: #838383;\n}", ""]);

// exports
